export default "/_next/static/chunks/fonts/Montserrat Medium-ec1be8f514e774a7ba200c43a03cf570.otf";